import { render, staticRenderFns } from "./TagBasicIcon.vue?vue&type=template&id=1221ffb4&scoped=true"
import script from "./TagBasicIcon.vue?vue&type=script&lang=js"
export * from "./TagBasicIcon.vue?vue&type=script&lang=js"
import style0 from "./TagBasicIcon.vue?vue&type=style&index=0&id=1221ffb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221ffb4",
  null
  
)

export default component.exports